import WidgetsMgr from 'widgets/widgetsMgr';
import 'widgets/widgetsList';

/*
Don't delete next comment, it's a placeholder for additional imports
See details in documentation/tools/WebpackConfiguration.md
 */
import 'plugin_quickbuy/quickBuyWidgetsList.ts';
import 'drop_int_klarna_payments_sfra/klarnaWidgetLists.ts';
import 'int_sterling_oms/widgetsList.ts';
import 'int_adyen_SFRA/adyenWidgetLists.ts';
import 'plugin_applepay/applepayWidgetsList.ts';
import 'int_google_verification/googleWidgetsList.ts';
import 'plugin_serviceworker/sw-registration.ts';
import 'int_gtm/clientGTM.ts';
import 'app_custom_core/app_custom_core.ts';
import 'core/widgetsList';
import './widgets/widgetsList';

WidgetsMgr.run();

if (module.hot) {
    module.hot.accept(['widgets/widgetsList', 'core/widgetsList'], () => WidgetsMgr.restartWidgets());
}
